import { render, staticRenderFns } from "./productState.vue?vue&type=template&id=55bf8653&scoped=true&"
import script from "./productState.vue?vue&type=script&lang=js&"
export * from "./productState.vue?vue&type=script&lang=js&"
import style0 from "./productState.vue?vue&type=style&index=0&id=55bf8653&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf8653",
  null
  
)

export default component.exports